import { RowSelectionType } from "antd/es/table/interface";
import * as React from "react";
import { PropsSelection } from "./types";
import { SingleSelection } from "./SingleSelection";
import { MultipleSelection } from "./MultipleSelection";

export const makeSelection = (
  type: RowSelectionType | undefined,
  props: PropsSelection,
): React.ReactNode => {
  if (type === "radio") {
    return <SingleSelection {...props} />;
  }
  if (type === "checkbox") {
    return <MultipleSelection {...props} />;
  }
  return null;
};
